export const GoogleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6 10.2272C19.6 9.51816 19.5364 8.83634 19.4182 8.18179H10V12.05H15.3818C15.15 13.3 14.4455 14.3591 13.3864 15.0682V17.5772H16.6182C18.5091 15.8363 19.6 13.2727 19.6 10.2272Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 19.9998C12.7001 19.9998 14.9637 19.1044 16.6183 17.5771L13.3864 15.068C12.491 15.668 11.3455 16.0226 10.0001 16.0226C7.39554 16.0226 5.19099 14.2635 4.40463 11.8998H1.06372V14.4908C2.70918 17.7589 6.09099 19.9998 10.0001 19.9998Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.40455 11.9001C4.20455 11.3001 4.09091 10.6592 4.09091 10.0001C4.09091 9.341 4.20455 8.70009 4.40455 8.1001V5.50919H1.06364C0.386364 6.85919 0 8.38646 0 10.0001C0 11.6137 0.386364 13.141 1.06364 14.491L4.40455 11.9001Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 3.97727C11.4683 3.97727 12.7864 4.48182 13.8228 5.47273L16.691 2.60455C14.9592 0.990909 12.6955 0 10.0001 0C6.09099 0 2.70918 2.24091 1.06372 5.50909L4.40463 8.1C5.19099 5.73636 7.39554 3.97727 10.0001 3.97727Z"
      fill="#EA4335"
    />
  </svg>
);
